// src/features/task/services/taskTimeBox.ts
// TimeBox 排程狀態：addScheduledTimeBox, removeScheduledTimeBox, updateLastTimeboxedDate
import {
  doc,
  updateDoc,
  arrayUnion,
  arrayRemove,
  serverTimestamp,
} from 'firebase/firestore';
import { db } from '../../../config/firebase';
import { logger } from '../../../utils/logger';
import { TASKS_COLLECTION } from './taskConverters';

// 添加排程 TimeBox 到任務（不改變 status）
const addScheduledTimeBox = async (
  taskId: string,
  timeBoxId: string
): Promise<void> => {
  try {
    const taskRef = doc(db, TASKS_COLLECTION, taskId);
    await updateDoc(taskRef, {
      scheduledTimeBoxIds: arrayUnion(timeBoxId),
      updatedAt: serverTimestamp(),
    });
  } catch (error) {
    logger.error('添加排程 TimeBox 失敗:', error);
    throw error;
  }
};

const removeScheduledTimeBox = async (
  taskId: string,
  timeBoxId: string,
  lastTimeboxedDate: string | undefined,
): Promise<void> => {
  try {
    const taskRef = doc(db, TASKS_COLLECTION, taskId);
    await updateDoc(taskRef, {
      scheduledTimeBoxIds: arrayRemove(timeBoxId),
      lastTimeboxedDate: lastTimeboxedDate ?? null,
      updatedAt: serverTimestamp(),
    });
  } catch (error) {
    logger.error('移除排程 TimeBox 失敗:', error);
    throw error;
  }
};

const updateLastTimeboxedDate = async (
  taskId: string,
  lastTimeboxedDate: string | undefined,
): Promise<void> => {
  try {
    const taskRef = doc(db, TASKS_COLLECTION, taskId);
    await updateDoc(taskRef, {
      lastTimeboxedDate: lastTimeboxedDate ?? null,
      updatedAt: serverTimestamp(),
    });
  } catch (error) {
    logger.error('更新 lastTimeboxedDate 失敗:', error);
    throw error;
  }
};

export const taskTimeBoxMethods = {
  addScheduledTimeBox,
  removeScheduledTimeBox,
  updateLastTimeboxedDate,
};
